export const getCurrentAcademicYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // Enero = 1

    // Si estamos de Julio a Diciembre, curso actual + siguiente año Si estamos de
    // Enero a Junio, curso anterior + año actual
    if (month >= 7) {
        return year;
    } else {
        return year - 1;
    }
};

export const formatTime = (timeString) => {
    if (!timeString) 
        return '';
    const [hours, minutes] = timeString.split(':');
    return `${hours}:${minutes}`;
};

export const getDayName = (dayCode) => {
    const days = {
        '1': 'Lunes',
        '2': 'Martes',
        '3': 'Miércoles',
        '4': 'Jueves',
        '5': 'Viernes',
        '6': 'Sábado',
        '7': 'Domingo'
    };
    return days[dayCode] || dayCode;
};

export const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

export const validatePhone = (phone) => {
    const re = /^\d{9}$/;
    return re.test(phone);
};

export const copyToClipboard = (text, onSuccess, onError) => {
    // Si no hay texto, no hacer nada
    if (!text || text.trim() === '') {
        if (onError) 
            onError('No hay texto para copiar');
        return Promise.reject('No hay texto para copiar');
    }

    // Método 1: Usar navigator.clipboard.writeText (método moderno)
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator
            .clipboard
            .writeText(text)
            .then(() => {
                console.log('Texto copiado al portapapeles:', text.substring(0, 50) + '...');
                if (onSuccess) 
                    onSuccess('Texto copiado al portapapeles');
                return true;
            })
            .catch(err => {
                console.error('Error con navigator.clipboard:', err);
                // Si falla, intentar método alternativo
                return copyToClipboardFallback(text, onSuccess, onError);
            });
    } else {
        // Método 2: Usar método alternativo (fallback)
        return copyToClipboardFallback(text, onSuccess, onError);
    }
};

// Método alternativo para navegadores que no soportan navigator.clipboard
const copyToClipboardFallback = (text, onSuccess, onError) => {
    return new Promise((resolve, reject) => {
        try {
            // Crear un textarea temporal
            const textArea = document.createElement('textarea');
            textArea.value = text;

            // Hacerlo no visible
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.style.opacity = '0';

            // Añadir al DOM
            document
                .body
                .appendChild(textArea);

            // Seleccionar y copiar
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');

            // Remover el textarea
            document
                .body
                .removeChild(textArea);

            if (successful) {
                console.log(
                    'Texto copiado al portapapeles (método fallback):',
                    text.substring(0, 50) + '...'
                );
                if (onSuccess) 
                    onSuccess('Texto copiado al portapapeles');
                resolve(true);
            } else {
                const errorMsg = 'No se pudo copiar el texto';
                console.error(errorMsg);
                if (onError) 
                    onError(errorMsg);
                reject(new Error(errorMsg));
            }
        } catch (err) {
            console.error('Error en método fallback:', err);
            if (onError) 
                onError('Error al copiar el texto');
            reject(err);
        }
    });
};

// Comparador de textos según el locale 'es' (ñ, acentos, mayúsculas/minúsculas)
const esCollator = new Intl.Collator('es', { sensitivity: 'base', numeric: true });

export const compareEs = (a, b) => esCollator.compare(a ?? '', b ?? '');

export const filterBySearchTerm =(items, term, matcher) => {
    if (!Array.isArray(items)) {
        return [];
    }

    const normalizedTerm = (term || '').trim().toLowerCase();
    if (!normalizedTerm) {
        return items;
    }

    return items.filter(item => matcher(item, normalizedTerm));
};

// Función auxiliar para obtener emails de alumnos
export const getStudentEmails = (students, emailField = 'Email1') => {
    if (!students || !Array.isArray(students) || students.length === 0) {
        return '';
    }

    return students
        .map(student => student[emailField])
        .filter(email => email && email.trim() !== '')
        .join('; ');
};
